<div class="flex flex-col">
  <div class="grid grid-cols-2 gap-2 items-center">
    <div>
      <div *ngIf="!addingApplicant" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Entity</span>
        <span class="font-semibold">Applicants</span>
      </div>

      <div *ngIf="newApplicantCreated" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Add</span>
        <span class="font-semibold">Applicant</span>
      </div>

      <div *ngIf="addingApplicant && !newApplicantCreated" class="flex flex-col md:flex-row gap-1">
        <span class="font-semibold">Update</span>
        <span class="font-semibold">Applicant</span>
      </div>

    </div>
    <div class="gap-2 flex justify-self-end items-center">
      <span *ngIf="applicants.length > 0 && !addingApplicant">Click Entry to Manage</span>

      <button type="button" *ngIf="!addingApplicant"
              mat-button color="primary" (click)="createApplicant()">Add</button>

      <button type="button" *ngIf="!addingApplicant"
              mat-button color="primary" (click)="getApplicants(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>

      <button type="button" *ngIf="addingApplicant && applicantForm.valid && applicant.id > 0 && !locked"
              mat-button color="primary" (click)="saveApplicant()">Save</button>

      <button type="button" *ngIf="addingApplicant && applicant.id > 0"
              mat-button color="warn" (click)="archiveApplicant(applicant, !applicant.archived)">{{ applicant.archived? 'Un-Archive' : 'Archive' }}</button>

      <button type="button" *ngIf="addingApplicant"
              mat-button color="warn" (click)="toggleApplicantForm(false)">Close</button>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="!addingApplicant">
    <mat-table [dataSource]="applicantSource" matSort #applicantSort="matSort" aria-describedby="entity applicants" class="mat-elevation-z8">
      <ng-container matColumnDef="entityName">
        <mat-header-cell *matHeaderCellDef mat-sort-header="">Entity Name</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">Name</span>
          {{ applicant.entityName }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="primaryContactName">
        <mat-header-cell *matHeaderCellDef>Contact Name</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">Contact</span>
          <div class="flex flex-col">
            <span>{{ applicant.primaryContactName }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="archived">
        <mat-header-cell *matHeaderCellDef>Archived</mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant" (click)="selectApplicant(applicant)">
          <span class="mobile-label">Archived</span>
          <div class="flex flex-col">
            <span>{{ applicant.archived? 'Yes' : 'No' }}</span>
          </div>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell tabindex="0" *matCellDef="let applicant">
          <div class="flex flex-row justify-start items-center">
            <button type="button" mat-icon-button [color]="applicant.archived? 'primary' : 'warn'" (click)="archiveApplicant(applicant, !applicant.archived)"
                    [matTooltip]="applicant.archived? 'Un-Archive Applicant' : 'Archive Applicant'" matTooltipShowDelay="500" matTooltipHideDelay="200">
              <mat-icon *ngIf="!applicant.archived">archive</mat-icon>
              <mat-icon *ngIf="applicant.archived">unarchive</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="applicantColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: applicantColumns" class="hover:bg-gray-500 hover:bg-opacity-25"
               [ngClass]="row.archived? 'bg-red-100 bg-opacity-25 text-black' : ''"></mat-row>
    </mat-table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20]" #applicantPaginator="matPaginator">
    </mat-paginator>
  </div>

  <div class="flex flex-col" *ngIf="addingApplicant">
    <form [formGroup]="applicantForm">
      <div class="flex flex-col md:flex-row gap-2">
        <mat-card class="flex flex-col md:w-1/2 gap-2 pt-3">
          <mat-card-content>
            <mat-card [style.background]="sharedService.darkMode? '#303030' : ''">
              <mat-card-content>
                <div class="flex flex-col md:flex-row gap-2">
                  <div class="flex flex-col gap-2 md:w-1/2">
                    <span class="font-semibold">Entity Name</span>
                    <mat-form-field>
                      <mat-label>Entity Name</mat-label>
                      <input matInput formControlName="entityName">
                      <mat-error *ngIf="applicantForm.get('entityName').invalid">
                        A name is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <span class="font-semibold">Primary Contact Name</span>
                    <mat-form-field>
                      <mat-label>Name</mat-label>
                      <input matInput formControlName="primaryContactName">
                      <mat-error *ngIf="applicantForm.get('primaryContactName').invalid">
                        A name is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2">
                  <div class="flex flex-col gap-2 md:w-1/2">
                    <span class="font-semibold">Primary Contact Email</span>
                    <mat-form-field>
                      <mat-label>Email</mat-label>
                      <input matInput formControlName="primaryContactEmail">
                      <mat-error *ngIf="applicantForm.get('primaryContactEmail').hasError('required')">
                        An email is required
                      </mat-error>
                      <mat-error *ngIf="applicantForm.get('primaryContactEmail').hasError('pattern')">
                        This does not look like a valid email
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <span class="font-semibold"><strong>Primary Contact Number</strong></span>
                    <mat-form-field>
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="primaryContactNumber" mask="000-00-0000">
                      <mat-error *ngIf="applicantForm.get('primaryContactNumber').invalid">
                        A phone number is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col md:flex-row gap-2">
                  <div class="flex flex-col gap-2 md:w-1/2">
                    <mat-checkbox formControlName="businessInOregon">
                      <span class="text-wrap">Entity is located in Oregon</span>
                    </mat-checkbox>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2" *ngIf="applicantForm.get('businessInOregon').value">
                    <span class="font-semibold"><strong>Secretary of State Number</strong></span>
                    <mat-form-field>
                      <mat-label>SOS Number</mat-label>
                      <input matInput formControlName="secretaryOfStateNumber">
                    </mat-form-field>
                  </div>
                </div>

                <mat-checkbox formControlName="registeredBusiness">
                  <span class="text-wrap">Business is registered</span>
                </mat-checkbox>

                <div class="flex flex-col md:flex-row gap-2" *ngIf="applicantForm.get('registeredBusiness').value">
                  <div class="flex flex-col gap-2 md:w-1/2">
                    <span class="font-semibold">Registered In</span>
                    <mat-form-field>
                      <mat-label>Registered In</mat-label>
                      <mat-select formControlName="registeredIn">
                        <mat-option *ngFor="let state of sharedService.states" value={{state}}>{{state}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <span class="font-semibold"><strong>Registry Number</strong></span>
                    <mat-form-field>
                      <mat-label>Number</mat-label>
                      <input matInput formControlName="registryNumber">
                    </mat-form-field>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </mat-card-content>
        </mat-card>

        <div class="flex flex-col md:w-1/2">
          <address [entityId]="applicant.id"
                   [entityType]="sharedService.entityApplicant"
                   [statuses]="statuses"></address>

          <document [entityId]="applicant.id"
                    [entityType]="sharedService.entityApplicant"
                    [statuses]="statuses"></document>
        </div>
      </div>
    </form>
  </div>
</div>
